import React from "react";
import { ConnectedRouter } from "connected-react-router";
import { Provider } from "react-redux";
import { Route, Switch } from "react-router-dom";

import configureStore, { history } from "./store";
import App from "./containers/App";
//import CacheBuster from "./CacheBuster";

export const store = configureStore();

const MainApp = () => (
  <Provider store={store}>
    <ConnectedRouter history={history}>
      <Switch>
        <Route path="/" component={App} />
      </Switch>
    </ConnectedRouter>
  </Provider>
);

//const MainApp = () => {
//  return (
//    <CacheBuster>
//      {({ loading, isLatestVersion, refreshCacheAndReload }) => {
//        if (loading) return null;
//        if (!loading && !isLatestVersion) {
//          refreshCacheAndReload();
//        }

//        return (
//          <Provider store={store}>
//            <ConnectedRouter history={history}>
//              <Switch>
//                <Route path="/" component={App} />
//              </Switch>
//            </ConnectedRouter>
//          </Provider>
//        );
//      }}
//    </CacheBuster>
//  );
//};

export default MainApp;
